var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CenterLayout',[_c('div',{staticClass:"text-center"},[_c('h3',[_vm._v("Weiterleitung nicht gefunden :/")]),_c('router-link',{staticClass:"btn btn-outline-primary",attrs:{"to":{ name: 'Redirect' }}},[_vm._v(" Zurück ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }